import { ReactNode, useMemo, useState } from 'react';

import { ESeatStatus } from '../domains/buy-ticket/types';
import { useWagonData } from './train-data-provider';

import styles from './components.module.css';

export const TrainCarContainer = ({ children }: { children: ReactNode }) => {
  const wagonData = useWagonData();

  return (
    <div
      className={styles.trainCarContainer}
      data-disabled={wagonData?.disabled}
      data-dir={wagonData?.direction}
    >
      {children}
    </div>
  );
};

type SeatProps = {
  num: number;
  nearWindow?: boolean;
  dir?: 'forward' | 'backward';
};
export const Seat = ({
  num,
  nearWindow = false,
  dir = 'forward',
}: SeatProps) => {
  const wagonData = useWagonData();
  const seatData = wagonData?.seatsMap.get(num);

  const [isSelected, setSelected] = useState(false);

  const seatNum = useMemo(() => {
    if (num <= 0) return '??';
    if (num <= 9) return `0${num}`;

    return num;
  }, [num]);

  const isAvailable =
    seatData?.status === ESeatStatus.free ||
    (seatData?.status === ESeatStatus.booked &&
      new Date(seatData?.bookingExpDate || 0).getTime() < Date.now());

  return (
    <button
      className={styles.seat}
      data-selected={isSelected}
      data-seat={num}
      data-dir={dir}
      data-window={nearWindow}
      data-available={isAvailable}
      onClick={() => setSelected(!isSelected)}
    >
      <span className={styles.seatNum}>{seatNum}</span>
    </button>
  );
};

export const Row = ({
  justify = 'left',
  children,
}: {
  justify?: 'left' | 'right';
  children: ReactNode;
}) => (
  <div data-justify={justify} className={styles.row}>
    {children}
  </div>
);

export const Col = ({
  // align = 'start',
  children,
}: {
  // align?: 'start' | 'end';
  children: ReactNode;
}) => <div className={styles.col}>{children}</div>;

export const SeatsContainer = ({
  align = 'start',
  children,
}: {
  align?: 'start' | 'end';
  children: ReactNode;
  onClick: () => void;
}) => {
  const wagonData = useWagonData();

  const handleSeatClick = (event: any) => {
    const seatNum = event.target?.dataset?.seat;
    if (!seatNum) return;

    wagonData?.onSeatClick(Number(seatNum));
  };

  return (
    <div
      className={styles.seatsContainer}
      data-align={align}
      onClick={handleSeatClick}
    >
      {children}
    </div>
  );
};

export const SeatSpace = ({ h = 16, v = 16 }: { h?: number; v?: number }) => (
  <div style={{ width: `${h}px`, height: `${v}px`, flexGrow: 2 }}></div>
);

export const DirectionArrow = () => {
  return (
    <div className={styles.directionArrowContainer}>
      <span className={styles.directionArrowText}>
        Направление движения поезда
      </span>
    </div>
  );
};

export const UnknownType = () => <span>??</span>;
